import * as React from 'react'
import { getMetricsPublisherChainAsync } from '@amzn/aapn-front-end-metrics'

type useChromeOnboardingTreatmentReturn = {
  isConsoleEnabled: boolean | undefined
  isConsoleLoading: boolean
}

export const useChromeOnboardingTreatment = (): useChromeOnboardingTreatmentReturn => {
  const [isEnabled, setIsEnabled] = React.useState<boolean>()
  const [isLoading, setIsLoading] = React.useState<boolean>(true)

  React.useEffect(() => {
    const fetchWeblab = async (): Promise<void> => {
      if ((window as any).__AAC_CHROME_HIDE_WC_NAVS_PROMISE__ instanceof Promise) {
        const shouldHideChromeNav = await (window as any).__AAC_CHROME_HIDE_WC_NAVS_PROMISE__
        setIsEnabled(!shouldHideChromeNav)
        getMetricsPublisherChainAsync('AdsConsoleInt').then((p) => p.publishCounter('ads-console-weblab-enabled', 1))
      } else {
        setIsEnabled(false)
      }
      setIsLoading(false)
    }
    fetchWeblab()
  }, [])

  return {
    isConsoleEnabled: isEnabled,
    isConsoleLoading: isLoading,
  }
}
